import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import ScheduleGradeAlertNotesEditModal from './Elements/ScheduleGradeAlertNotesEditModal';

class ScheduleGradeAlerts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      modal: false,
      updated: 0,
      loaded: 0,
      updated: 0,
      data: [],
      data_alert: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.refreshUpdated = this.refreshUpdated.bind(this);
    this.showModal = this.showModal.bind(this);
    this.EditNote = this.EditNote.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.rowClasses = this.rowClasses.bind(this);
    this.loadData = this.loadData.bind(this);
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }


  loadData (event) {
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/alertas/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.status === 'success') {
          self.setState({aircraft_model: responseJson.data.aircraft_model});
          self.setState({schedule: responseJson.data.schedule});
          self.setState({data: responseJson.data.alerts});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  EditNote (cell, row) {
    var url = "";
    var botao = (
      <div className="btn-group">
        <button onClick={this.showModal.bind(this, row)} className='btn btn-sm btn-primary' alt='Editar' title='Editar'><i className="fa fa-fw fa-pencil"></i></button>
      </div>
    );

    return botao;
  }
  ActionsButtons (cell, row) {
    var url = "";
    var botao = (
      <div className="btn-group">
        {(row.controlled === 1) ?
          <button className="btn btn-sm btn-danger" value={cell} onClick={this.archive}><i className="fa fa-check"></i></button>
          :
          <button className="btn btn-sm btn-success" value={cell} onClick={this.activate}><i className="fa fa-check"></i></button>
        }
      </div>
    );

    return botao;
  }

  MessageFormat (cell, row) {
    var url = "";
    var botao = (
      <div dangerouslySetInnerHTML={{__html: row.message}}></div>
    );

    return botao;
  }
  rowClasses (row, rowIdx) {
    if(typeof row !== 'undefined') {
      return "text-center box-alert box-alert-" + row.color;
    } else {
      return '';
    }
  }

  showModal(row, event) {
    this.setState({modal:true, data_alert: row});
  }

  refreshUpdated (event) {
    this.setState({modal:false, updated: 0, data_alert: []});
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/alertas/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.status === 'success') {
          self.setState({aircraft_model: responseJson.data.aircraft_model});
          self.setState({schedule: responseJson.data.schedule});
          self.setState({data: responseJson.data.alerts});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.ativar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/alerta/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({data: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.arquivar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/alerta/arquivar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({data: responseJson.data});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{self.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.titulo} - {self.state.aircraft_model} - {self.state.schedule}</h3>
      <Link to={"/escala/grade/" + self.props.match.params.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable trClassName={this.rowClasses} data={this.state.data} pagination={true} exportCSV={true} options={{exportCSVText: this.locale.general.ExportarCsv, noDataText: this.locale.general.semDados}} search={true} multiColumnSearch={true} searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="color_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Cor}</TableHeaderColumn>

        <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Tipo}</TableHeaderColumn>

        <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='60'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Mat}</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='150'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Nome}</TableHeaderColumn>

        <TableHeaderColumn dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Regime}</TableHeaderColumn>

        <TableHeaderColumn dataField="aircraft" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Aeronave}</TableHeaderColumn>

        <TableHeaderColumn dataField="sector" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Responsavel}</TableHeaderColumn>

        <TableHeaderColumn dataField="controlled_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='100'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Controlado}</TableHeaderColumn>

        <TableHeaderColumn dataField="message" dataAlign="center" dataFormat={this.MessageFormat} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}width='350'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Alerta}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.EditNote} width='70'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Comentarios}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='60'>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.ListaGradesDeEscalaAlertas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>


      <ScheduleGradeAlertNotesEditModal RequestApi={this.refs.request_api} refreshUpdated={this.refreshUpdated} handleAlert={this.handleAlert} modal={this.state.modal} data={this.state.data_alert} />

    </div>
  </div>
</div>
    );
  }
}

export default ScheduleGradeAlerts;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradeAlerts.js